import PropTypes from 'prop-types';

export const propTypes = {includedExtrasAndDrivers: PropTypes.array,
  addedExtras: PropTypes.array,
  selectedBundle: PropTypes.object,
  addedExtrasAmount: PropTypes.number,
  bundledAdditionalDrivers: PropTypes.number,};
